<template>
    <div class="command-container">
        <span>
            <span class="requiredrank moderaattori" v-if="moderaattori">Moderaattori</span>
            <span class="requiredrank operaattori" v-if="operaattori">Operaattori</span>
            <span class="requiredrank admin" v-if="admin">Admin</span>
            <code v-if="command || params" class="command">
                <span class="name" v-if="command">/{{ command }}</span>
                <span class="params" v-if="params">{{ params }}</span>
            </code>

            <span class="desc">{{ desc }}</span>
            <div v-if="example" class="example">
                <code>{{ example }}</code>
            </div>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Command',
    props: {
        params: {
            type: String
        },
        command: {
            type: String
        },
        desc: {
            type: String
        },
        example: {
            type: String
        },
        moderaattori: {
            type: Boolean
        },
        operaattori: {
            type: Boolean
        },
        admin: {
            type: Boolean
        }
    }
}
</script>

<style scoped>
code {
    background: var(code-bg);
    padding: 0.2em 0.5em;
    color: var(--code-1);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.4em;
    padding-left: 0;
}

.name {
    margin-right: 0.5em;
}

.params {
    color: var(--code-2);
    margin-right: 0.2em;
}

.desc {
    font-size: 0.9em;
    color: var(--code-desc);
}

.example code {
    color: var(--code-3);
}

.command-container {
    margin-bottom: 0.5em;
    background: var(--code-bg);

    padding-left: 0.4em;
}

.requiredrank {
    display: block;
    font-size: 0.8em;
}

.moderaattori {
    color: #b922a3 !important;
}

.operaattori {
    color: #dc3588 !important;
}

.admin {
    color: #ff476c !important;
}

.requiredrank::before {
    content: '[';
    color: #fa0 !important;
}
.requiredrank::after {
    content: ']';
    color: #fa0 !important;
}
</style>
